import { parseTs } from "../../../shared/time";

export { parseTs };

/** Time zone for displaying moments (the person's profile setting). */
let displayTz: string | undefined;
export function setDisplayTimeZone(tz: string | null | undefined) {
  try { displayTz = tz ? (new Intl.DateTimeFormat(undefined, { timeZone: tz }), tz) : undefined; } catch { displayTz = undefined; }
}

/** A calendar date (effective, review): "Oct 14, 2026". */
export const fmt = (s: string | null | undefined): string => {
  const d = parseTs(s);
  return d ? d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "-";
};

/** A moment something happened (submitted, approved, viewed): "Oct 14, 2026, 2:35 PM". */
export const fmtDT = (s: string | null | undefined): string => {
  const d = parseTs(s);
  if (!d) return "-";
  // Plain dates have no time worth showing.
  if (/^\d{4}-\d{2}-\d{2}$/.test(String(s).trim())) return fmt(s);
  return d.toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", timeZone: displayTz });
};

/** A due date shown with its deadline time: "Oct 14, 2027, 11:59 PM" (end of that day). */
export const fmtDue = (s: string | null | undefined): string => {
  const d = parseTs(s);
  if (!d) return "-";
  d.setHours(23, 59, 0, 0);
  return d.toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
};

export const bytes = (b: number): string =>
  !b ? "-" : b < 1048576 ? `${Math.max(1, Math.round(b / 1024))} KB` : `${(b / 1048576).toFixed(1)} MB`;

/** Whole days from today to a date (negative = past). */
export const daysUntil = (s: string | null | undefined): number | null => {
  const d = parseTs(s);
  if (!d) return null;
  const today = new Date();
  today.setHours(12, 0, 0, 0);
  return Math.round((d.getTime() - today.getTime()) / 864e5);
};

export const isoDate = (d: Date): string =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const plusDays = (n: number): string => isoDate(new Date(Date.now() + n * 864e5));

export const initials = (name: string): string =>
  name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]!.toUpperCase()).join("") || "?";

const AVATAR_COLORS = ["#3E4651", "#8A5A2B", "#2F6F6A", "#6B4E8A", "#2F6FB3", "#1F8A5B", "#9A4815", "#5D6470"];
export const avatarColor = (id: string): string => {
  let h = 0;
  for (const c of id) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length]!;
};

export const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

export const IS_MAC = /Mac|iPhone|iPad/i.test(
  (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData?.platform || navigator.platform || navigator.userAgent || ""
);
export const KEY_HINT = IS_MAC ? "⌘K" : "Ctrl K";

/** Save a Blob as a file. */
export function saveBlob(blob: Blob, name: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
